export default "__VITE_ASSET__2c541938__"